import * as React from "react";
import Constants from "../Action/Constants";
import { browserHistory } from "react-router";
import Translator from "../Translation/Translator";
import Filterer from "../Table/Filterer";
import Http from "../Http/Http";
import Image from "../Image/Image";
import Formatter from "../Localization/Formatter";
import History from "../Browser/History";
import Syncronizer from "../Form/Syncronizer/Syncronizer";
import { MiddlewareInterface } from "../Middleware/MiddlewareInterface";
import CurrencyContainer from "../Currency/CurrencyContainer";
import { CurrencyInterface } from "../Currency/CurrencyInterface";
import PaymentOffsetContainer from "../Entity/Entities/Charge/PaymentOffset/PaymentOffsetContainer";
import { PaymentOffsetInterface } from "../Entity/Entities/Charge/PaymentOffset/PaymentOffsetInterface";
import LanguageContainer from "../Translation/LanguageContainer";
import { LanguageInterface } from "../Translation/LanguageInterface";
import { CompanyInterface } from "../Entity/Entities/Company/CompanyInterface";
import { BankAccountInterface } from "../Entity/Entities/BankAccount/BankAccountInterface";
import LocaleContainer from "../Entity/Entities/Locale/LocaleContainer";
import Time from "../Time/Time";
import * as Scroll from 'react-scroll';
// import { call } from "redux-saga/effects";
import Store from "../Store/Store";
import MenuItem from '@material-ui/core/MenuItem';
import Decoder from "../Token/Decoder";
import Token from "../Token/Token";
import CalculationContainer from "../Entity/Entities/BrokenMonthCalculation/CalculationContainer";


abstract class Component extends React.Component<any, any> {

  protected readonly syncronizers = Syncronizer.getSyncronizers();
  protected image = Image;
  protected http = Http;
  protected formatter = Formatter;
  protected translator = Translator;
  protected table = {
    filterer: Filterer
  };
  protected browser = {
    history: History
  };
  protected form = {
    syncronizer: Syncronizer
  };
  protected leaving: boolean = false;
  protected event: any;
  protected middlewares: MiddlewareInterface[] = [];
  protected shouldClearBeforeUnmounting?: boolean;
  protected clearWith?: string | string[];

  public state: any = {
    scrollToError: ""
  };

  constructor(public props) {
    super(props);

    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  public isUserHasAccess = (): boolean => {
    if (typeof Store.getConfigurator().getState().app.session.user.isAdmin === "function"
        && Store.getConfigurator().getState().app.session.user.isAdmin()) {
      return true;
    }

    return false;
  }

  public checkProcessIsBusy = (_dataObject: object): boolean => {
    // we suppose that maybe we will use dataObject in the future 
    // to check isBusy flag of specific entity/process
    // but now we just check isBusy of agency
    const isBusy = Store.getConfigurator().getState().app.settings.agency.isBusy;
    if (!isBusy) {
      return isBusy;
    }
    if (isBusy) {
      this.props.dispatch({
        type: Constants.GLOBAL_GET_AGENCY_LIST,
      });
    }
    return Store.getConfigurator().getState().app.settings.agency.isBusy;
  }

  public openIsBusyPopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_IS_BUSY_POPUP_OPEN
    });
  }

  public closeIsBusyPopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_IS_BUSY_POPUP_CLOSE
    });
  }

  public saveDetailsBeforeRedirect = (page?: string | string[], statePropertyName?: string) => {
    const initialHasModifiedData = this.state.hasModifiedData;
    const initialAdditionalSectionHasModifiedData = this.state.additionalSectionHasModifiedData;
    this.state.hasModifiedData = false;
    this.state.additionalSectionHasModifiedData = false;

    const savedDataBeforeRedirecting = {...this.props.app.savedDataBeforeRedirecting};
    const dataToBeSaved = {...this.state};

    if (initialHasModifiedData) {
      dataToBeSaved.hasModifiedData = true;
    }

    if (initialAdditionalSectionHasModifiedData) {
      dataToBeSaved.additionalSectionHasModifiedData = true;
    }

    if (!!page) {
      if (typeof page === "string") {
        savedDataBeforeRedirecting[page + "DataToBeSaved"] = dataToBeSaved;
      } else {
        page.forEach(page => savedDataBeforeRedirecting[page + "DataToBeSaved"] = dataToBeSaved);
      }
    } else {
      savedDataBeforeRedirecting.dataToBeSaved = dataToBeSaved;
    }

    // if we have few same type lookup companents on one page we should specify statePropertyName
    // because system should know for which component we create entity
    if (!!statePropertyName) {
      savedDataBeforeRedirecting["statePropertyName"] = statePropertyName;
    }

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
      }
    });
  }

  public sync(...args: any[]): void {
    this.form.syncronizer.sync(this, ...args);
  }

  public setModifiedData(): void {
    this.setState({
      hasModifiedData: true
    });
  }

  public getAgency() {
    const agency: CompanyInterface = this.props.app?.companies?.find((company: CompanyInterface) => company?.isAgency);
    return agency;
  }

  public getAgencyBankAccounts(): BankAccountInterface[] {
    return this.props.app.bankAccounts
      .filter((bankAccount: BankAccountInterface) =>  !!bankAccount &&
        !bankAccount.removed &&
        bankAccount.companyId === this.getAgency()?.id)
  }

  public isBeta() {
    return this.props?.app?.settings?.user?.beta || false;
  }

  protected getErrorFor(field: string): any {
    if (!field) {
      return "";
    }

    const errorFields: string[] = !!this.props.component ? [...this.props.component.fields] : [];
    const error = !errorFields ? false : errorFields.find(prop => {
      return prop === field;
    });

    if (errorFields.length === 0 && this.state.scrollToError) {
      this.setState({
        scrollToError: ""
      })
    }

    if (error) {
      if (errorFields[0] !== this.state.scrollToError) {
        const scroller = Scroll.scroller;
        const scrollToElement = "scroll-to-" + errorFields[0];

        this.setState({
          scrollToError: errorFields[0]
        })

        scroller.scrollTo(scrollToElement, {
          duration: 500,
          delay: 100,
          smooth: true,
          offset: -200
        });
      }

      return this.props.component.translatedMessage;
    }

    return "";
  }

  protected isFieldEmpty(field: string, value: any): any  {

    if (value?.toString().trim()) {
      return false
    }

    const scroller = Scroll.scroller;
    const scrollToElement = "scroll-to-" + field;
    scroller.scrollTo(scrollToElement, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -200
    });

    return true;
  }

  protected getDetailErrorFor(field: string): string {
    if (!field) {
      return "";
    }

    const errorFields = !!this.props.component ? [...this.props.component.fields] : [];
    const error = !errorFields ? false : errorFields.find(prop => {
      return prop.field === field;
    });

    if (errorFields.length === 0 && this.state.scrollToError) {
      this.setState({
        scrollToError: ""
      })
    }

    if (error) {
      if (errorFields[0] !== this.state.scrollToError) {
        const scroller = Scroll.scroller;
        const scrollToElement = "scroll-to-" + errorFields[0];

        this.setState({
          scrollToError: errorFields[0]
        })

        scroller.scrollTo(scrollToElement, {
          duration: 500,
          delay: 100,
          smooth: true,
          offset: -200
        });
      }

      return this.trans(error.errorId)
    } else {
      return "";
    }
  }

  protected trans(key: string, params: any = {}, locale: string = "", sendToLogger: boolean = true): string {
    if (!!Store.getConfigurator().getState().app.isLanguageKeySwitchOn) {
      return key;
    }

    return Translator.trans(!!key && key.toLowerCase(), params, locale, sendToLogger);
  }

  protected saving(callback?): void {
    this.setState({
      isSaving: true,
      hasModifiedData: false,
      additionalSectionHasModifiedData: false
    }, () => {
      if (typeof callback === "function") {
        callback();
      }
    });
  }

  public convertToInteger(value: any): any {
    return isNaN(value) === false ? parseInt(value, 10) : value;
  }

  public stay(): any {
    this.setState({
      openLeavePrompt: false,
      leave: false
    });
  }

  public leave(_event): any {
    this.setState({
      openLeavePrompt: false,
      hasModifiedData: false,
      additionalSectionHasModifiedData: false,
      leave: true
    });

    this.forceCancel();
  }

  protected cancel(event: any = {}): void {
    this.event = event;

    if (this.hasModifiedData() && !this.state.leave) {
      this.setState({
        openLeavePrompt: true
      });
      return;
    }

    this.forceCancel();
  }

  public forceCancel(): any {
    if(!!this.event) {
      if (typeof this.event.payload !== "undefined") {
        this.props.dispatch(this.event);
      }
    }

    // if leaving path to page === previous page we use redirect back, other we redirect to routerLeavingToPath page.
    if (this.state.routerLeavingToPath === this.browser.history.getPreviousPage()) {
      return this.redirectBack();
    }

    if (typeof this.state.routerLeavingToPath === "string") {
      this.redirect(this.state.routerLeavingToPath, true);
      return;
    }

    this.redirectBack();
  }

  protected redirect(path: string, forceLeave: boolean = false): any {
    if (this.state && this.hasModifiedData()) {
      this.setState({nextPath: path});
    }

    document.documentElement.style.height = "auto";
    // React-router doesn't unmount leave preventation instantly so we need this hack.
    if (forceLeave === true) {
      return setTimeout(() => {
        browserHistory.push(path);
      }, 10);
    } else {
      if (location.href.includes("/create") && this.state.nextPath) {
        return browserHistory.goBack();
      }

      if (path === this.browser.history.getPreviousPage()) {
        this.setState({nextPath: ''}, () => {
          browserHistory.goBack();
        })
      } else {
        return browserHistory.push(path);
      }
    }
  }

  protected locationReplace(path: string): void {
    document.documentElement.style.height = "auto";
    browserHistory.replace(path);
  }

  protected redirectBack = (): void => {
    document.documentElement.style.height = "auto";

    browserHistory.goBack();
  }

  protected redirectFewStepsBack(steps: number): void {
    document.documentElement.style.height = "auto";

    for(let i = 0; i < steps; i++) {
      this.redirectBack();
    }
  }

  protected getIdentityTypeSelectboxes(): any[] {
    return Object.keys(this.props.globalTypes?.IdentityType || {})
    .map((item) => {
      let identityType = this.props.globalTypes?.IdentityType?.[item]
      return (
      <MenuItem key={identityType?.id} value={identityType?.id} className="identity-type-el">{Formatter.checkTranslationType(this.trans(identityType?.label), identityType?.label)}</MenuItem>
      );
    });
  }

  protected getUnitTypeSelectboxes(): any[] {
    return Object.keys(this.props.globalTypes?.UnitType || {}).sort((unitType1, unitType2) => {
      if(Formatter.checkTranslationType(Translator.trans(this.props.globalTypes?.UnitType?.[unitType1]?.label), this.props.globalTypes?.UnitType?.[unitType1]?.label).toLowerCase() < Formatter.checkTranslationType(Translator.trans(this.props.globalTypes?.UnitType?.[unitType2]?.label), this.props.globalTypes?.UnitType?.[unitType2]?.label).toLowerCase()) { return -1; }
      if(Formatter.checkTranslationType(Translator.trans(this.props.globalTypes?.UnitType?.[unitType1]?.label), this.props.globalTypes?.UnitType?.[unitType1]?.label).toLowerCase() > Formatter.checkTranslationType(Translator.trans(this.props.globalTypes?.UnitType?.[unitType2]?.label), this.props.globalTypes?.UnitType?.[unitType2]?.label).toLowerCase()) { return 1; }
      return 0;
    }).map((item) => {
      let unitType = this.props.globalTypes?.UnitType?.[item];
      return (
      <MenuItem key={unitType?.id} value={unitType?.id} className="unit-type-el">{Formatter.checkTranslationType(this.trans(unitType?.label), unitType?.label)}</MenuItem>
      );
    })
  }

  protected getUnitServiceStatusTypeSelectboxes(): any[] {
    return Object.keys(this.props.globalTypes?.UnitServiceStatus || {}).map((item) => {
      let unitServiceStatusType = this.props.globalTypes?.UnitServiceStatus?.[item]

      return (
      <MenuItem key={unitServiceStatusType?.id} value={unitServiceStatusType?.id} className="unit-service-status-type-el">{this.trans(`unit_service_status_type_${unitServiceStatusType?.label?.toLowerCase()}`)}</MenuItem>
      );
    });
  }

  protected getAssignmentServiceStatusTypeSelectBoxes(): any[] {
     return Object.keys(this.props.globalTypes?.AssignmentServiceStatus || {}).map((item) => {
       let assignmentServiceStatusType = this.props.globalTypes?.AssignmentServiceStatus?.[item]
  
       return (
       <MenuItem key={assignmentServiceStatusType?.id} value={assignmentServiceStatusType?.id} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${assignmentServiceStatusType?.label?.toLowerCase()}`)}</MenuItem>
       );
     });
  }

  protected getGenderTypeSelectboxes(): any[] {
    return Object.keys(this.props.globalTypes?.GenderType || {}).map((item) => {
      let genderType = this.props.globalTypes?.GenderType?.[item]
      return (
      <MenuItem key={genderType?.id} value={genderType?.id} className="gender-type-el">{this.trans(`gender_type_${genderType?.label}`)}</MenuItem>
      );
    });
  }

  protected getLanguageTypeSelectboxes(): any[] {
    return Object.keys(this.props.globalTypes?.LanguageType || {}).map((item) => {
      let LanguageType = this.props.globalTypes?.LanguageType?.[item]
      return (
      <MenuItem key={LanguageType?.id} value={LanguageType?.id} className="language-type-el">{Formatter.checkTranslationType(this.trans(LanguageType?.label, {}, "", false), LanguageType?.label)}</MenuItem>
      );
    });
  }

  protected getLanguageSelectboxes(): any[] {
    return LanguageContainer.all().map((language: LanguageInterface, index: number) => {
      return (
        <MenuItem key={index} value={language?.iso}>{this.trans(language?.iso)}</MenuItem>
      );
    });
  }

  protected getCalculationSelectboxes(): any[] {
    return CalculationContainer.all().map((calculation: {value: string, translationKey: string}, index: number) => {
      return (
        <MenuItem key={index} value={calculation?.value}>{this.trans(calculation?.translationKey)}</MenuItem>
      );
    });
  }

  protected getLocaleSelectboxes(): any[] {
    return LocaleContainer.all().map((locale: {value: string, translationKey: string}, index: number) => {
      return (
        <MenuItem key={index} value={locale?.value}>{this.trans(locale?.translationKey)}</MenuItem>
      );
    });
  }

  protected getCurrencySelectboxes(): any[] {
    /*
    |  Sometimes our session expires on the backend but because of race conditions, we re-render the page.
    |  However, session data disappears before we unmount/remount the component.
    |  This small workaround temporarily solves the crashes we're having on PaymentUpdate page.
    |  @todo Make sure we remove session data after everything has been unmounted.
    |  @todo Add a HoC that wraps Page Components and blocks the render if settings are missing.
    */

    let param = null;

    if (this.props.app.settings.user !== null) {
      param = this.props.app.settings.user.currency;
    }

    return CurrencyContainer
    .getInstances(param)
    .map((currency: CurrencyInterface, index: number) => {
      return (
        <MenuItem key={index} value={currency.getCurrencyId()}>{currency.getName()}</MenuItem>
      );
    });
  }

  protected getRepeatPeriodSelectboxes(): any[] {
    return Object.keys(this.props.globalTypes?.RepeatPeriod || {}).map((period) => {
      let periodType = this.props.globalTypes?.RepeatPeriod?.[period]
      return (
        <MenuItem key={periodType?.id} value={periodType?.id}>{Formatter.checkTranslationType(this.trans(periodType?.label), periodType?.label)}</MenuItem>
      );
    });
  }

  protected getRepeatPeriodAgreementSelectboxes(typeId = null): any[] {
    return Object.keys(this.props.globalTypes?.RepeatPeriod || {})?.filter((period) => { 
      let periodType = this.props.globalTypes?.RepeatPeriod?.[period];

      // If tenant search is chosen, we are hiding monthly
      if (typeId === 2) {
        return periodType?.label !== "weekly" && periodType?.label !== "yearly" && periodType?.label !== "monthly"
      }
      return periodType?.label !== "weekly" && periodType?.label !== "yearly"
    })?.map((period) => {
      let periodType = this.props.globalTypes?.RepeatPeriod?.[period];

      return (
        <MenuItem key={periodType?.id} value={periodType?.id}>{Formatter.checkTranslationType(this.trans(periodType?.label), periodType?.label)}</MenuItem>
      );
    });
  }

  protected getPaymentOffsetSelectboxes(): any[] {
    return PaymentOffsetContainer.getInstances().map((paymentOffset: PaymentOffsetInterface, index: number) => {
      return (
        <MenuItem key={index} value={paymentOffset.getValue()}>{paymentOffset?.getName()}</MenuItem>
      );
    });
  }

  protected getSixMonthsForReportsSelectboxes(): any[] {
    return Time.sixMonthsForReports().map((month, index) => {
      return (
        <MenuItem key={index} value={month.value}>{month.label}</MenuItem>
      );
    });
  }
  protected getTwoYearsForReportsSelectboxes(): any[] {
    return Time.twoYearsForReport().map((year, index) => {
      return (
        <MenuItem key={index} value={year.value}>{year.label}</MenuItem>
      );
    });
  }

  protected routerWillLeave(route: any): boolean {
    const storageToken = Token.getInstant() && Decoder.decode(Token.getInstant());

    // If token is not valid we should leave the path
    if (!storageToken || (!!storageToken && storageToken.isExpired)) {
      return true;
    }

    this.setState({
      routerLeavingToPath: route.pathname
    });

    if (this.hasModifiedData()) {
      this.event = {};

      if (this.browser.history.getPreviousPage() && this.browser.history.getPreviousPage().includes("create")) {
        this.setState({
          openLeavePrompt: true
        });

        return false;
      }

      this.setState({
        nextPath: route.pathname,
        openLeavePrompt: true
      });

      return false;
    }

    return true;
  }

  public componentWillMount(): void {
    this.middlewares.forEach((middleware: MiddlewareInterface) => {
      return middleware.applyComponent(this).process();
    });
  }

  public componentWillUnmount() {
    if (this.shouldClearBeforeUnmounting === true) {
      if (typeof this.clearWith === "string") {
        this.props.dispatch({
          type: this.clearWith
        });
      } else {
        const clearWithArr = [...this.clearWith];
        clearWithArr.forEach(clearWith => {
          this.props.dispatch({
            type: clearWith
          });
        });
      }
    }

    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  protected hasModifiedData(): boolean {
    return this.state.hasModifiedData || this.state.additionalSectionHasModifiedData;
  }

  protected _handlePageChange(step: number, functionPrefix: string = "startStep") {
    return this[`${functionPrefix}${step}`]();
  }

  public render() {
    return null;
  }
}

export default Component;
